var _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 32 24",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 24,
    maskUnits: "userSpaceOnUse",
    width: 32,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h32v24h-32z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h32v24h-32z",
    fill: "#f7fcff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 14.6667v2h32v-2z",
    fill: "#e31d1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 18.3333v2h32v-2z",
    fill: "#e31d1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 7.33325v2h32v-2z",
    fill: "#e31d1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 22v2h32v-2z",
    fill: "#e31d1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 11v2h32v-2z",
    fill: "#e31d1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0v2h32v-2z",
    fill: "#e31d1c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 3.66675v2h32v-2z",
    fill: "#e31d1c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h20v13h-20z",
    fill: "#2e42a5"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m1.72197 2.93871-.725883.50888.245063-.90561-.644714-.57391h.842084l.28243-.73907.33117.73907h.71786l-.56404.57391.21836.90561zm4 0-.72588.50888.24506-.90561-.64471-.57391h.84208l.28243-.73907.33117.73907h.71786l-.56404.57391.21836.90561zm3.27412.50888.72588-.50888.70233.50888-.2184-.90561.5641-.57391h-.7179l-.33115-.73907-.28243.73907h-.84208l.64471.57391zm4.72591-.50888-.7259.50888.2451-.90561-.6448-.57391h.8421l.2825-.73907.3311.73907h.7179l-.5641.57391.2184.90561zm-12.725913 4.50888.725883-.50888.70233.50888-.21836-.90561.56404-.57391h-.71786l-.33117-.73907-.28243.73907h-.842084l.644714.57391zm4.725883-.50888-.72588.50888.24506-.90561-.64471-.57391h.84208l.28243-.73907.33117.73907h.71786l-.56404.57391.21836.90561zm3.27412.50888.72588-.50888.70233.50888-.2184-.90561.5641-.57391h-.7179l-.33115-.73907-.28243.73907h-.84208l.64471.57391zm4.72591-.50888-.7259.50888.2451-.90561-.6448-.57391h.8421l.2825-.73907.3311.73907h.7179l-.5641.57391.2184.90561zm-12.725913 4.50889.725883-.5089.70233.5089-.21836-.9056.56404-.57393h-.71786l-.33117-.73907-.28243.73907h-.842084l.644714.57393zm4.725883-.5089-.72588.5089.24506-.9056-.64471-.57393h.84208l.28243-.73907.33117.73907h.71786l-.56404.57393.21836.9056zm3.27412.5089.72588-.5089.70233.5089-.2184-.9056.5641-.57393h-.7179l-.33115-.73907-.28243.73907h-.84208l.64471.57393zm4.72591-.5089-.7259.5089.2451-.9056-.6448-.57393h.8421l.2825-.73907.3311.73907h.7179l-.5641.57393.2184.9056zm3.2741-7.49111.7259-.50888.7023.50888-.2184-.90561.5641-.57391h-.7179l-.3311-.73907-.2825.73907h-.8421l.6448.57391zm.7259 3.49112-.7259.50888.2451-.90561-.6448-.57391h.8421l.2825-.73907.3311.73907h.7179l-.5641.57391.2184.90561zm-.7259 4.50889.7259-.5089.7023.5089-.2184-.9056.5641-.57393h-.7179l-.3311-.73907-.2825.73907h-.8421l.6448.57393zm-13.27413-6.50889-.72588.50888.24506-.90561-.64471-.57391h.84208l.28243-.73907.33117.73907h.71786l-.56404.57391.21836.90561zm3.27412.50888.72588-.50888.70233.50888-.21836-.90561.56404-.57391h-.71786l-.33117-.73907-.28243.73907h-.84208l.64471.57391zm4.72591-.50888-.7259.50888.2451-.90561-.6448-.57391h.8421l.2825-.73907.3311.73907h.7179l-.5641.57391.2184.90561zm-8.72591 4.50888.72588-.50888.70233.50888-.21836-.90561.56404-.57391h-.71786l-.33117-.73907-.28243.73907h-.84208l.64471.57391zm4.72588-.50888-.72588.50888.24506-.90561-.64471-.57391h.84208l.28243-.73907.33117.73907h.71786l-.56404.57391.21836.90561zm3.27413.50888.7259-.50888.7023.50888-.2184-.90561.5641-.57391h-.7179l-.3311-.73907-.2825.73907h-.8421l.6448.57391zm4.7259-4.50888-.7259.50888.2451-.90561-.6448-.57391h.8421l.2825-.73907.3311.73907h.7179l-.5641.57391.2184.90561zm-.7259 4.50888.7259-.50888.7023.50888-.2184-.90561.5641-.57391h-.7179l-.3311-.73907-.2825.73907h-.8421l.6448.57391z",
    fill: "#f7fcff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/USA.c318bb55db69953e7ede7c0ff01788df.svg";
export { ForwardRef as ReactComponent };